import { useCallback } from 'react';
import useApi from './useApi';
import { CoatingItem } from '../types/CoatingTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getCoatings = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}GetCoatings`,
            });
        } catch (error) {
            console.error('Failed to fetch coatings:', error);
        }
    }, [getApiData, appSettings]);


    // Get the coatings data
    const getCoatingsData = (): CoatingItem[] => {
        if (state.status === 'success' && state.result) {
            let rawCoatings: any[] = [];
            if (Array.isArray(state.result)) {
                rawCoatings = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawCoatings = state.result.data;
            } else if (typeof state.result === 'object') {
                rawCoatings = [state.result];
            }
            // Normalize property names (API may return PascalCase or camelCase)
            return rawCoatings.map((item: any) => ({
                id: item.id ?? item.Id,
                name: item.name ?? item.Name ?? '',
                type: item.type ?? item.Type ?? 0,
                isActive: item.isActive ?? item.IsActive ?? true,
                manufacturerId: item.manufacturerId ?? item.ManufacturerId ?? 0,
                manufacturerName: item.manufacturerName ?? item.ManufacturerName ?? '',
            }));
        }
        return [];
    };

    return {
        coatings: getCoatingsData(),
        loading: state.isLoading,
        error: state.error,
        getCoatings,
        status: state.status,
    };
};
